import { render, staticRenderFns } from "./SimpleButton.vue?vue&type=template&id=13c674f4&"
import script from "./SimpleButton.vue?vue&type=script&lang=js&"
export * from "./SimpleButton.vue?vue&type=script&lang=js&"
import style0 from "./SimpleButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports